<app-stages [stages]="stages" currentStage="Dane wniosku">
</app-stages>
<br>
@if (!pending() && !loading()) {
  <form novalidate autocomplete="off" [formGroup]='form' (ngSubmit)='submitAndGoNext()'>
    <div class="row">
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"office" as controlName'>
          <label [for]='controlName'>
            Wniosek składany do *
          </label>
          <input
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Urząd'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"documentReceiptMethod" as controlName'>
          <label [for]='controlName'>
            Sposób odbioru *
          </label>
          <select
            (change)="form.documentReceiptMethodChange(form.getElement($event).value)"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'>
            <option value=''>Wybierz</option>
            <option [value]='item?.id' *ngFor='let item of methods()'>
              {{ item.name }}
            </option>
          </select>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      @if (form.documentReceiptMethod.value === '2d8f8c02-14f2-428f-beae-6faadbc75170') {
        <div class="col-12">
          <app-alert [closable]="false">
            Odbiór osobisty jest możliwy po uprzednim umówieniu się telefonicznym z pracownikiem merytorycznym, przy
            odbiorze należy okazać dokument tożsamości.
          </app-alert>
        </div>
      }
      @if (form.ePuapAddress) {
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"ePuapAddress" as controlName'>
            <label [for]='controlName'>
              Adres skrzynki E-puap *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu adres skrzynki E-puap'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.eDeliveryAddress) {
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"eDeliveryAddress" as controlName'>
            <label [for]='controlName'>
              Adres skrzynki E-doręczeń *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu adres skrzynki E-doręczeń'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
    </div>
    <div class="row">
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"municipality" as controlName'>
          <label [for]='controlName'>
            Wniosek składany przez gminę *
          </label>
          <select
            (change)="form.municipalityChange(form.getElement($event).value)"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'>
            <option value=''>Wybierz</option>
            @for (item of form.municipalities; track $index) {
              <option [value]='item'>{{ item }}</option>
            }
          </select>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      @if (form.otherMunicipality) {
        <div class='col-md-6'>
          <div class='form-group' *ngIf='"otherMunicipality" as controlName'>
            <label [for]='controlName'>
              Inna gmina *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu nazwę gminy'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
    </div>
    <br>
    <app-exposed-map-control [control]="form.geometry">
    </app-exposed-map-control>
    <br>
  </form>
  <div class='application-actions'>
    <button
      type='button'
      class='btn btn-secondary'
      (click)='onCancel()'>
      <span>
        Wstecz
      </span>
    </button>
    <button
      type='button'
      class='btn btn-primary'
      (click)='submitAndGoNext()'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
